export default "__VITE_ASSET__BPWkvD_o__"